import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class SalesImportsService {
  url :string = environment.url;

  private readonly _records = new BehaviorSubject<any>(<any>[]);
  public records$ = this._records.asObservable();

  public gettingRecords :boolean = false;

  constructor(
    private translate :TranslateService,
    private http :HttpClient,
  ) {
    // this.get({ page: 1, per_page: 20 })
  }

  // po list
  get(params) {
    this.gettingRecords = true;

    return this.http.post(`${this.url}/sales_imports`, params).pipe(
      tap((_) => {
        this.gettingRecords = false;
      }),
    );
  }

  getSummary(params) {
    this.gettingRecords = true;

    return this.http.post(`${this.url}/sales_imports/summary`, params).pipe(
      tap((_) => {
        this.gettingRecords = false;
      }),
    );
  }

  getMonthlySummary(params) {
    this.gettingRecords = true;

    return this.http.post(`${this.url}/sales_imports/monthly_summary`, params).pipe(
      tap((_) => {
        this.gettingRecords = false;
      }),
    );
  }
}
